import "./Services.module.css";
import Header from "@/reusable_sections/Header";
import ServiceCategories from "./sections/ServiceCategories";
import FreeShopEstimate from "./sections/FreeShopEstimate";
import Footer from "@/reusable_sections/Footer";
export default function ServicesPage() {
  return <div>
      <Header />
      <ServiceCategories />
      <FreeShopEstimate />
      <Footer />
    </div>;
}